import React from 'react';
import { ReportData } from '@/types/report';
import { ExecutiveSummary } from '../report/ExecutiveSummary';
import { ResultsOverview } from '../report/ResultsOverview';
import ScrollToTopButton from '../common/FloatingActionButton';
import CareerAcceleratorView from '../report/CareerAcceleratorView';
import { SelfAssessmentView } from '../report/SelfAssessmentView';
import LeadershipEdge from '../report/LeadershipEdge';
import { GrowView } from '../report/GrowView';
import { EvaluatorsView } from '../report/EvaluatorsView';
import { CollaboratorGeniusView } from '../report/CollaboratorGeniusView';

interface ExampleReportContentProps {
  activeTab: string;
  reportData: ReportData;
  visibleTabs?: string[];
}

export function ExampleReportContent({ 
  activeTab, 
  reportData,
  visibleTabs = ['general', 'self-assessment', 'evaluators', 'grow', 'leadership', 'career', 'collaborator']
}: ExampleReportContentProps) {
  // Ensure active tab is in visible tabs, otherwise default to first visible tab
  const effectiveTab = visibleTabs.includes(activeTab) ? activeTab : visibleTabs[0] || 'general';

  return (
    <div className="border-t border-gray-200">
      <ScrollToTopButton />
      {effectiveTab === 'career' && visibleTabs.includes('career') && reportData ? (
        <CareerAcceleratorView />
      ) : effectiveTab === 'general' ? (
        <>
          <ExecutiveSummary name="Example User" />
          <ResultsOverview reportData={reportData} />
        </>
      ) : effectiveTab === 'self-assessment' && visibleTabs.includes('self-assessment') ? (
        <SelfAssessmentView />
      ) : effectiveTab === 'leadership' && visibleTabs.includes('leadership') ? (
        <LeadershipEdge />
      ) : effectiveTab === 'grow' && visibleTabs.includes('grow') ? (
        <GrowView />
      ) : effectiveTab === 'evaluators' && visibleTabs.includes('evaluators') ? (
        <EvaluatorsView />
      ) : effectiveTab === 'collaborator' && visibleTabs.includes('collaborator') ? (
        <CollaboratorGeniusView />
      ) : null}
    </div>
  );
}